/**
 * 店铺装修， 活动页装修 内容管理
 */
import {
    get,
    post
} from '@/utils/request'

// 查询商户店铺列表
export const queryPharmacy = params => post('/popPharmacy/queryPharmacy', params)

// pop商家分类分页列表
export const getPopDirectoryList = params => get('/popdirectory/list', params)

// 添加分类
export const addPopDirectory = params => post('/popdirectory/add', params)

// 禁用商家分类
export const disablePopDirectory = params => get(`/popdirectory/disable/${params.id}`)

// 启用商家分类
export const enablePopDirectory = params => get(`/popdirectory/enable/${params.id}`)

// pop店铺分类编辑页面详情
export const getPopDirectoryDetail = params => get(`/popdirectory/edit/${params.id}`)

// pop店铺分类编辑保存
export const editPopDirctory = params => post('/popdirectory/edit', params)

// 查询erp分类
export const queryErpDirectory = params => get('/popdirectory/queryErpDirectorys', params)

// 刷新分类缓存
export const refreshDirectoryCache = () => get('/popdirectory/refreshCache')

// 一键发布
export const addOneKeyIssue = params => post('/popact/synchroPublishStatus', params)
/**
 * 店铺装修
 */

// 查询可装修店铺列表
export const queryPopactShopList = params => get('/popact/shoplist', params)

// 店铺分类排序
export const saveSort = params => post('/popdirectory/sort', params)

/**
 * 基础服务 - 店铺管理
 */

// 店铺管理-分页查询列表
export const queryShopList = params => post('/shop/apply/list', params, {
    TYPE: 'JSON'
})

// 店铺管理-操作上线或下线
export const enableShop = params => post('/shop/apply/enable', params)

// 店铺管理-编辑、新增
export const editShop = params => post('/shop/apply/save', params, {
    TYPE: 'JSON'
})

// 店铺管理-详情
export const detailShop = params => get('/shop/apply/detail', params)

// 店铺管理-详情
export const shopClassification = params => get('/shop/apply/classification', params)



/*店铺分类（按商品）开始*/

//查询店铺分类列表
export const queryShopType = params => get('/categoryByProduct/list', params)
//查询关联商品列表
export const queryGoodsList = params => get('', params)
//导入关联商品列表
export const importGoods = params => post('/categoryByProduct/productsBatch', params, {
    TYPE: 'FILE'
})
//查询编辑弹框数据
export const goodsEidt = params => get('/categoryByProduct/edit/' + params.id)
//刷新缓存
export const handleRefreshCache = params => get('/categoryByProduct/refreshCache', params)
//保存排序
export const saveShopSort = params => post('/categoryByProduct/sort', params)
//保存新增
export const saveClassif = params => post('/categoryByProduct/add', params, {
    TYPE: 'JSON'
})
//禁用商家分类
export const classDisable = params => get('/categoryByProduct/disable/' + params.id)
//启用商家分类
export const classEnable = params => get('/categoryByProduct/enable/' + params.id)

//保存编辑
export const editClassif = params => post('/categoryByProduct/editSave', params, {
    TYPE: 'JSON'
})
/*店铺分类（按商品）结束*/